import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWhiteboard2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconWhiteboard2"><Path d="M20.5 4.5V19.5M20.5 4.5H12M20.5 4.5H21.5M20.5 19.5H3.5M20.5 19.5H21.5M3.5 19.5V4.5M3.5 19.5H2.5M3.5 4.5H12M3.5 4.5H2.5M12 4.5V3.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconWhiteboard2;
